// Reviews and maintenance logged by hand against a whole section (the "Last review" header chip),
// not against a single row. Every section that grows a chip adds a kind here rather than a table.
export const REVIEW_ENTRY_KINDS = {
  ASSET_INVENTORY_REVIEW: 'asset_inventory_review',
  IT_INVENTORY_REVIEW: 'it_inventory_review',
  IT_INVENTORY_MAINTENANCE: 'it_inventory_maintenance',
  RISK_MANAGER_REVIEW: 'risk_manager_review',
} as const

export type IReviewEntryKind = (typeof REVIEW_ENTRY_KINDS)[keyof typeof REVIEW_ENTRY_KINDS]

// Ordered values backing the `review_entry_kind` Postgres enum (see src/db/schema/tables/reviewEntries.ts)
export const REVIEW_ENTRY_KIND_VALUES = [
  REVIEW_ENTRY_KINDS.ASSET_INVENTORY_REVIEW,
  REVIEW_ENTRY_KINDS.IT_INVENTORY_REVIEW,
  REVIEW_ENTRY_KINDS.IT_INVENTORY_MAINTENANCE,
  REVIEW_ENTRY_KINDS.RISK_MANAGER_REVIEW,
] as const

// How the review or maintenance went. It is what colours the dot in the history list.
// The stored values stay generic on purpose: the labels in the locales are expected to be
// reworded, and copy changes should never cost an ALTER TYPE.
export const REVIEW_ENTRY_STATUSES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  FAILED: 'failed',
} as const

export type IReviewEntryStatus = (typeof REVIEW_ENTRY_STATUSES)[keyof typeof REVIEW_ENTRY_STATUSES]

// Ordered values backing the `review_entry_status` Postgres enum
export const REVIEW_ENTRY_STATUS_VALUES = [
  REVIEW_ENTRY_STATUSES.SUCCESS,
  REVIEW_ENTRY_STATUSES.WARNING,
  REVIEW_ENTRY_STATUSES.FAILED,
] as const
